import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { Petition } from '@ncessor/shared';
import { MatList, MatListItem } from '@angular/material/list';
import { NgFor } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DateRangePipe } from '../../pipes/date-range.pipe';

@Component({
  selector: 'app-petition-state-list',
  templateUrl: './petition-state-list.component.html',
  styleUrls: ['../category-content-page.scss'],
  imports: [MatList, NgFor, MatListItem, MatIconButton, MatIcon, DateRangePipe],
})
export class PetitionStateListComponent implements OnInit {
  @Input() petitions: Petition[] | null = null;
  @Input() title?: string;

  @Output() editClick = new EventEmitter<Petition>();
  @Output() deleteClick = new EventEmitter<Petition>();

  constructor() {}

  ngOnInit(): void {}

  onEditPetition(pet: Petition) {
    this.editClick.emit(pet);
  }

  onDeletePetition(pet: Petition) {
    this.deleteClick.emit(pet);
  }
}
